import { Routes, RouterModule } from '@angular/router';

// Components
import { BusinessComponent } from './business.component';
import { PTUComponent } from './components/ptu/ptu.component';
import { PDAComponent } from './components/pda/pda.component';
import { PTMComponent } from './components/ptm/ptm.component';
import { PTMIntermediateComponent } from './components/ptm-intermediate/ptm-intermediate.component';
import { PDComponent } from './components/pd/pd.component';
import { AfiliatesComponent } from './components/afiliates/afiliates.component';
import { UpAnalyticsComponent } from './components/up-analytics/up-analytics.component';

const routes: Routes = [
  { path: 'empresas', component: BusinessComponent },
  { path: 'afiliados', component: AfiliatesComponent },
  { path: 'afiliados/up-analytics', component: UpAnalyticsComponent },
  { path: 'empresas/ptu/:friendlyId', component: PTUComponent },
  { path: 'empresas/ptu', pathMatch: 'full', redirectTo: '/empresas' },
  { path: 'empresas/pda/:friendlyId', component: PDAComponent },
  { path: 'empresas/pda', pathMatch: 'full', redirectTo: '/empresas' },
  { path: 'empresas/ptm/:friendlyId', component: PTMComponent },
  { path: 'empresas/ptm', pathMatch: 'full', redirectTo: '/empresas' },
  { path: 'empresas/ptm/intermediate/:friendlyId', component: PTMIntermediateComponent },
  { path: 'empresas/ptm/intermediate', pathMatch: 'full', redirectTo: '/empresas' },
  { path: 'empresas/pd/:friendlyId', component: PDComponent },
  { path: 'empresas/pd', pathMatch: 'full', redirectTo: '/empresas' },
  { path: 'tarjetas', redirectTo: 'empresas', pathMatch: 'full' },
  { path: 'empresas/contactenos', redirectTo: '/contacto', pathMatch: 'full' }
];

export const BUSINESS_ROUTES = RouterModule.forChild(routes);
